import React from "react"
import PropTypes from "prop-types"
import MDBDataTable from "../../components/Common/MDBDataTable"
import { Row, Col, Card, CardBody, CardTitle, Spinner } from "reactstrap"
import "./datatables.scss"

const LogsList = React.memo(function LogsList({
    logs,
    title = "Error Logs",
    option = [10, 20, 30, 40, 60, 80, 100, 200],
    default_entries = 20,
    displayEntries = true,
    searching = true,
    paging = true,
    loading = false
}) {
    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="mdi mdi-account-group-outline font-18 mr-2"></i> {title}
                        </CardTitle>
                        <CardBody>
                            {loading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <MDBDataTable
                                    responsive
                                    bordered
                                    data={logs}
                                    entriesOptions={option}
                                    entries={default_entries}
                                    displayEntries={displayEntries}
                                    searching={searching}
                                    paging={paging}
                                    responsiveLg={true}
                                    responsiveMd={true}
                                    theadColor="primary"
                                    tbodyColor="light"
                                    hover={true}
                                    sortable
                                />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
});

LogsList.propTypes = {
    logs: PropTypes.shape({
        columns: PropTypes.arrayOf(PropTypes.object),
        rows: PropTypes.arrayOf(PropTypes.object),
    }),
    title: PropTypes.string,
    option: PropTypes.arrayOf(PropTypes.number),
    default_entries: PropTypes.number,
    displayEntries: PropTypes.bool,
    searching: PropTypes.bool,
    paging: PropTypes.bool,
    loading: PropTypes.bool,
}

export default LogsList
